//
//

import {
    mapActions, mapGetters, mapMutations, mapState
} from "vuex";
import { uid, date } from "quasar";
import {
    editProcessPermissions,
    publishAppPermissions,
    infoToastPublish
} from "@/assets/js/appFunc";
import _merge from "lodash.merge";
import Wysiwyg from "@/components/DocumentEditor/Froala/Froala.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import AQToast from "@/components/Generics/AQToast/AQToast.vue";
import AQMenu from "@/components/Generics/AQMenu/AQMenu.vue";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQHistory from "@/components/Generics/AQHistory/AQHistory.vue";
import AQList from "@/components/Generics/AQList/AQList.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQSkeleton from "@/components/Generics/AQSkeleton/AQSkeleton.vue";
import AQEmptyState from "@/components/Generics/AQEmptyState/AQEmptyState.vue";
import AQSearch from "@/components/Generics/AQSearch/AQSearch.vue";
import AQEmptySearch from "@/components/Generics/AQEmptySearch/AQEmptySearch.vue";
import { defaultDocument, defaultPagesProps } from "@/components/DocumentEditor/Froala/defaultDocument";
import { APP_DATE_DOT_FORMAT } from "@/assets/js/appConfig";
import i18n from "@/i18n/index";

export default {
    name: "Documents",
    components: {
        Wysiwyg,
        AQButton,
        AQDialog,
        AQToast,
        AQEmptyState,
        defaultPagesProps,
        AQList,
        AQInput,
        AQMenu,
        AQModal,
        AQHistory,
        AQSkeleton,
        AQSearch,
        AQEmptySearch
    },
    beforeRouteUpdate(to, from, next) {
        if (to.params.documentId && this.draft) {
            this.$nextTick(() => {
                this.$store.commit("main/setInterfaceDirty", true);
            });
        } else if (!from.query.search && to.query.search) {
            this.$store.commit("main/setSaveBtnVisible", true);
        } else if (!to.params.documentId && from?.params.documentId) {
            this.getDocumentsList();
            this.setReadOnly = false;
            this.inPreviewMode = false;
            this.showDoc = false;
            this.$root.$emit("setReadonlyTag", false);
            this.filter = "";
            this.refreshNotify();
            if (this.changeInDoc) {
                this.changeInDoc = false;
            } else if (this.draft) {
                this.selected = [defaultDocument()];
                this.draft = false;
            }
            this.selected = [defaultDocument()];
            this.updateSelectedDoc(this.selected);
            this.selectedFromState = null;
            this.dirtyFromRestore = false;
            this.$store.commit("main/setSaveBtnVisible", true);
            this.$oneAtATime.destroyCurrentRoom();
        }
        next();
    },
    data() {
        return {
            objToSend: {
                html: "",
                processDefinitionId: ""
            },
            filter: "",
            selected: [defaultDocument()],
            readonly: false,
            forceUpdatePicker: false,
            nameError: false,
            errorMessage: "",
            wrnMessage: "",
            draft: false,
            openDialog: false,
            openRenameDialog: false,
            changeInDoc: false,
            docUpdateNotify: null,
            newSelectionId: null,
            toastExist: false,
            draftDoc: null,
            deletedDoc: false,
            deleteDocDlg: false,
            selectedFromState: null,
            optionsMore: [{ name: "rename", label: this.$tc("documents.rename") }],
            hideListBtns: ["edit", "copy", "download"],
            hideBtnOnReadonly: ["edit", "copy", "delete", "more"],
            showDoc: false,
            skeleton: true,
            validateValueId: "",
            validateValueName: "",
            currentSession: false,
            saveHistoryData: [],
            saveHistoryModal: false,
            saveHistoryCurrentPage: 0,
            saveHistoryHasMoreItems: true,
            changeHistoryData: [],
            changeHistoryModal: false,
            changeHistoryCurrentPage: 0,
            changeHistoryHasMoreItems: true,
            saveHistoryActiveCommitId: null,
            savePreviewToast: null,
            currentPreviewDocument: null,
            standaloneTypes: new Set(["publish", "delete", "recover"]),
            openDialogDraftPreview: false,
            restoreConfirmationDialog: false,
            restoreDialogMessage: null,
            restoredDocumentData: null,
            previewDone: false,
            dirtyFromRestore: false,
            setReadOnly: false,
            inPreviewMode: false,
            docPreview: null,
            docRenamed: false,
            keyUpdate: 0,
            note: null,
            createNote: false,
            confirmLabel: null,
            noteDialogTitle: null,
            noteDialog: false,
            dialogAction: "",
            timeStampPreview: null,
            searchTrigger: false,
            isActive: true,
            firstLoad: false
        };
    },

    computed: {
        ...mapGetters("documentEditor", [
            "getExistingDocs",
            "loadingDocs",
            "getFieldFromDocuments",
            "loadingTemplates",
            "getFieldFromTemplates",
            "ddlDocOptions",
            "currentTemplate",
            "appWasUpdated"
        ]),
        ...mapGetters("main", ["getCurrentApplicationId", "interfaceDirty"]),
        ...mapGetters("version", ["latestVersionId"]),
        ...mapGetters("apps", ["currentApp", "processList", "getCurrentAppUserPermissions"]),
        ...mapState("documentEditor", ["existingDocs", "selectedDoc"]),

        filteredDocs() {
            return (this.filter && this.filter.length)
                ? this.getExistingDocs.filter(elem => elem.name.toLowerCase().includes(this.filter.toLowerCase()))
                : this.getExistingDocs;
        },

        createNoteDisabled() {
            return !this.note && this.createNote;
        },

        isReadonlyPermiss() {
            return this.$route.params.permissions && this.$route.params.permissions.readonly;
        },

        isReadonly() {
            return !this.$oneAtATime.state.$currentRoomEmpty;
        }
    },

    watch: {
        selected: {
            handler(newValue) {
                if (!this.draft && this.showDoc) {
                    const [newSelected] = newValue;
                    if (!this.changeInDoc) {
                        if (!this.selectedFromState) {
                            this.getDocumentDetails(newSelected.id).then((data) => {
                                if (!newSelected.pages.id && data.data.pages?.id) {
                                    newSelected.pages.id = data.data.pages.id;
                                }
                                this.selectedFromState = JSON.parse(JSON.stringify([{ ...data.data }]));
                                if (newSelected.id === this.selectedFromState[0].id) {
                                    if (this.selectedFromState[0].template === "<p></p>") {
                                        this.selectedFromState[0].template = "";
                                    }
                                    if (newSelected.template === "<p></p>") {
                                        newSelected.template = "";
                                    }
                                    this.changeInDoc = JSON.stringify(newSelected) !== JSON.stringify(this.selectedFromState[0]);
                                    if (!this.inPreviewMode) {
                                        this.$store.commit("main/setInterfaceDirty", this.changeInDoc);
                                        this.$root.$emit("showCheckedSaveBtn", !this.interfaceDirty);
                                    }
                                    this.selectedFromState = null;
                                }
                            });
                        }
                    }
                }
                const [{ pages } = {}] = this.selected || [];
                if (!pages) {
                    this.selected[0].pages = defaultPagesProps();
                }
            },
            deep: true
        },
        "$backendWebsocketEvents.state.refreshDocList": function (actionDetails) {
            if (actionDetails) {
                const { id, data } = actionDetails;
                const eventInfo = data.split(":");
                const idDoc = eventInfo[2];
                const actionType = eventInfo[3];
                if (this.currentApp.id === id) {
                    if (this.draft) {
                        this.draftDoc = { ...this.selected[0] };
                        this.refreshWithDraft();
                    } else if (actionType === "persist") {
                        this.refreshList(idDoc);
                    } else if (actionType === "delete") {
                        this.refreshAfterDelete(idDoc);
                    } else if (actionType === "rename") {
                        this.refreshAfterRename(idDoc);
                    } else if (actionType === "recover") {
                        this.getDocumentsList();
                    }
                }
                this.$backendWebsocketEvents.state.refreshDocList = false;
            }
        },
        showSearch: {
            handler(newVal) {
                this.searchTrigger = newVal;
                setTimeout(() => {
                    this.searchTrigger = false;
                }, 0);
            },
            immediate: true
        }
    },
    activated() {
        this.isActive = true;
        this.$root.$emit("previewSaveHistoryHeaderClose", this.$route.name);
        this.forceUpdatePicker = true;
        this.setSaveButtonDisplay();
        if (this.appWasUpdated) {
            this.getDocumentsList().then(() => {
                this.setAppUpdated(false);
            });
        }
        const { query, params } = this.$route;
        this.$store.commit("main/setInterfaceDirty", false);
        this.$root.$emit("showPublish", { noProcesses: this.currentApp.hasOwnProperty("nrOfProcesses")
            ? !this.currentApp.nrOfProcesses : !this.processList.length,
        showPublish: this.publishAppPermissions(this.currentApp, this.getCurrentAppUserPermissions) });
        this.$root.$emit("hideSaveBtn", false);
        this.$root.$emit("showCheckedSaveBtn", true);
        this.$store.commit("rules/setShowRuleTesting", false);
        const { id } = this.selected[0];
        this.getDocumentsList().then((data) => {
            this.skeleton = false;
            if (id) {
                this.$root.$emit("hideSaveBtn", false);
                this.$root.$emit("showCheckedSaveBtn", true);
                this.$oneAtATime.createRoom("documents", id);
                this.focusSelectedDoc();
                this.getDocData();
            } else if (params && params.documentId) {
                const documentToLoad = data.data.find(item => item.id === params.documentId);
                if (documentToLoad) {
                    this.openDoc(params.documentId);
                } else {
                    this.$router.replace({ path: `/applications/${this.currentApp.id}/documentTemplates`, params: {} });
                }
            } else if (query.search) {
                this.searchTrigger = false;
                this.$nextTick(() => {
                    this.searchTrigger = true;
                    this.filter = query.search;
                });
            } else {
                this.$root.$emit("hideSaveBtn", true);
                this.$root.$emit("showCheckedSaveBtn", false);
            }
        });
        this.draft = false;
        this.$root.$on("backendWebsocketEvents-publishedApp", data => {
            if (this.showDoc) {
                this.getDocumentDetails(this.selected[0].id).then((response) => {
                    if (this.selected[0].documentCommitId !== response.data.documentCommitId) {
                        this.selected[0].documentCommitId = response.data.documentCommitId;
                        const newSelectedDoc = {};
                        Object.entries(response.data).forEach(([key, value]) => {
                            if (this.selected[0][key]) {
                                newSelectedDoc[key] = this.selected[0][key];
                            } else {
                                newSelectedDoc[key] = value;
                            }
                        });
                        this.selected = [_merge(newSelectedDoc, this.selected[0])];
                        this.updateSelectedDoc(this.selected[0]);
                        if (!this.draft) {
                            this.docPreview[0].documentCommitId = response.data.documentCommitId;
                        }
                    }
                });
            }
            infoToastPublish(data);
            this.$root.$emit("changePublishError");
        });
        this.$root.$on("openNoteDialog", routeName => {
            if (routeName === this.$route.name) {
                this.getNoteData();
            }
        });
        this.$root.$on("previewSaveHistoryClose", routeName => {
            if (routeName === this.$route.name) {
                this.setReadOnly = false;
                this.inPreviewMode = false;
                if (this.savePreviewToast) {
                    this.savePreviewToast();
                }
                this.saveHistoryActiveCommitId = null;
                this.dirtyFromRestore = false;
                if (this.showDoc) {
                    this.selected = JSON.parse(JSON.stringify(this.docPreview));
                    this.updateSelectedDoc(this.selected[0]);
                }
                this.$root.$emit("hideSaveBtn", false);
                this.$root.$emit("showCheckedSaveBtn", true);
                this.changeInDoc = false;
                this.$store.commit("main/setInterfaceDirty", false);
                this.$emit("previewSaveHistoryClose", this.$route.name);
                this.$root.$emit("showPublish", { noProcesses: this.currentApp.hasOwnProperty("nrOfProcesses")
                    ? !this.currentApp.nrOfProcesses : !this.processList.length,
                showPublish: this.publishAppPermissions(this.currentApp, this.getCurrentAppUserPermissions) });
            }
        });
        this.$root.$on("openSaveHistory", routeName => {
            if (routeName === this.$route.name) {
                if (this.saveHistoryActiveCommitId) {
                    this.saveHistoryModal = true;
                    if (this.savePreviewToast) {
                        this.savePreviewToast();
                    }
                    this.$nextTick(() => {
                        const activePreviewListItem = document.querySelectorAll(".timeline_list_item.active.edit");
                        if (activePreviewListItem.length) {
                            activePreviewListItem[0].scrollIntoView();
                        }
                    });
                } else {
                    this.resetSaveHistory();
                    this.getSaveHistory();
                }
            }
        });
        this.$root.$on("showMoreSaveHistory", routeName => {
            if (routeName === this.$route.name) {
                this.saveHistoryCurrentPage += 1;
                this.getSaveHistory();
            }
        });
        this.$root.$on("showMoreChangeHistory", routeName => {
            if (routeName === this.$route.name) {
                this.changeHistoryCurrentPage += 1;
                this.getChangeHistory();
            }
        });
        this.$root.$on("openChangeHistory", routeName => {
            if (routeName === this.$route.name) {
                this.resetChangeHistory();
                this.getChangeHistory();
            }
        });
        this.$store.commit("main/setSaveBtnVisible", true);
        if (!this.firstLoad) {
            this.renameFromBc();
        }
    },
    created() {
        this.setSaveButtonDisplay();
        if (!this.processList.length) {
            this.getAppProcesses({ applicationId: this.currentApp.id, searchTerm: "" }).then(rsp => {
                if (rsp.data) {
                    this.$store.commit("apps/setProcessList", rsp.data);
                }
            });
        }
        this.$root.$on("restore", () => {
            this.infoRestoreDialog();
            this.restoreConfirmationDialog = true;
        });
    },
    mounted() {
        this.firstLoad = true;
        this.$root.$on("startEditing", () => {
            this.refreshNotify();
            this.getDocData();
        });
        this.$root.$on("oneAtATime-documents", () => {
            this.$root.$emit("setReadonlyTag", !this.$oneAtATime.state.$currentRoomEmpty);
            if (this.isReadonlyPermiss && this.$oneAtATime.state.$currentRoomEmpty) {
                this.getDocumentsList().then(() => {
                    const docAvailable = this.getExistingDocs.find(element => element.id === this.selected[0].id);
                    if (docAvailable) {
                        this.getDocumentDetails(this.selected[0].id).then((data) => {
                            this.selected = JSON.parse(JSON.stringify([{ ...data.data }]));
                            this.updateExistingDoc(this.selected[0]);
                        });
                    }
                });
            }
        });
        this.$root.$on("oneAtATime-documents-delete", value => {
            if (value === "false") {
                setTimeout(() => {
                    this.$toast.showNotify({
                        type: "error",
                        message: this.$t("oneAtATime.uiReadonlyMessage", { user: this.$oneAtATime.state.$currentEditingUser })
                    });
                }, 500);
            } else if (value === "true") {
                this.deleteDocument(this.selected[0]).then(() => {
                    this.$toast.showNotify({
                        type: "success",
                        message: this.$t("documents.successDelete"),
                        timeout: 3000
                    });
                    this.currentSession = true;
                    this.deletedDoc = true;
                    this.draft = false;
                    this.checkFreshAppData();
                    this.$oneAtATime.destroyCurrentRoom();
                    this.selected = [defaultDocument()];
                    this.$store.commit("main/setInterfaceDirty", false);
                    this.$root.$emit("hideSaveBtn", true);
                    this.$root.$emit("showCheckedSaveBtn", false);
                })
                    .catch(() => {
                        this.$oneAtATime.destroyCurrentRoom();
                        this.$toast.showNotify({
                            type: "error",
                            message: this.$t("documents.alreadyDeleted")
                        });
                    });
            }
        });
        this.$root.$on("oneAtATime-documents-rename", value => {
            if (value === "false") {
                setTimeout(() => {
                    this.$toast.showNotify({
                        type: "error",
                        message: this.$t("documents.cantBeRenamed", { user: this.$oneAtATime.state.$currentEditingUser })
                    });
                }, 500);
            } else if (value === "true") {
                this.currentSession = true;
                this.getDocumentsList().then(() => {
                    let currentDoc = this.existingDocs.find(elem => elem.id === this.validateValueId);
                    if (currentDoc) {
                        currentDoc.name = this.validateValueName;
                        const payload = {
                            appId: currentDoc.applicationId,
                            id: currentDoc.id,
                            name: currentDoc.name
                        };
                        this.saveDocumentsListName(payload).then(() => {
                            this.checkFreshAppData();
                            this.$toast.showNotify({
                                type: "success",
                                message: this.$t("documents.renamedSuccessfully"),
                                timeout: 2000
                            });
                            this.$oneAtATime.destroyCurrentRoom();
                            this.$store.commit("main/setInterfaceDirty", false);
                            currentDoc = null;
                        });
                    }
                });
            }
        });
        this.$root.$on("documentsSave", this.save);
        this.$root.$on("bc__documents__open", this.openDoc);
        this.renameFromBc();
    },
    deactivated() {
        this.isActive = false;
        this.setReadOnly = false;
        this.inPreviewMode = false;
        this.showDoc = false;
        this.firstLoad = false;
        this.$store.commit("main/setSaveBtnVisible", false);
        this.$root.$emit("setReadonlyTag", false);
        this.filter = "";
        this.refreshNotify();
        if (this.changeInDoc) {
            this.changeInDoc = false;
        } else if (this.draft) {
            this.selected = [defaultDocument()];
            this.draft = false;
        }
        this.selected = [defaultDocument()];
        this.updateSelectedDoc(this.selected);
        this.selectedFromState = null;
        this.$root.$off("backendWebsocketEvents-publishedApp");
        this.$root.$off("openSaveHistory");
        this.$root.$off("showMoreChangeHistory");
        this.$root.$off("openChangeHistory");
        this.$root.$off("showMoreSaveHistory");
        this.$root.$off("bc__currentDocument__rename");
        this.resetChangeHistory();
        this.resetSaveHistory();
        this.dirtyFromRestore = false;
        this.$root.$emit("previewSaveHistoryHeaderClose", this.$route.name);
        this.$root.$off("openNoteDialog");
    },
    beforeDestroy() {
        this.firstLoad = false;
        this.$root.$off("documentsSave");
        this.$root.$off("bc__documents__open");
        this.$root.$off("bc__currentDocument__rename");
    },
    methods: {
        ...mapActions("documentEditor", [
            "getDocumentsList",
            "getDocumentTemplate",
            "postNewDocument",
            "saveDocumentsListName",
            "saveChangedDocument",
            "deleteDocument",
            "postDocumentTemplate",
            "getDocumentDetails",
            "getDocCommitId"
        ]),
        ...mapMutations("documentEditor", ["updateDocumentList", "updateSelectedDoc", "setAppUpdated", "updateExistingDoc"]),
        ...mapMutations("main", ["setInterfaceDirty"]),
        ...mapActions("apps", ["getAppProcesses", "getAppSettingsInfo"]),
        ...mapActions("components", ["getHistoryData", "getNote", "saveDeleteNote"]),
        ...mapActions("documentEditor", ["getDocumentHistoryPreviewData", "recoverDocument"]),
        editProcessPermissions,
        publishAppPermissions,

        actionsDoc(event) {
            if (event.action === "edit") {
                this.openDoc(event.item.id);
            } else if (event.action === "rename") {
                this.nameError = false;
                this.showEditPopup(event);
            } else if (event.action === "download") {
                this.exportDoc(event.item, false, true);
            } else if (event.action === "delete") {
                this.deleteDoc(event.item);
            }
        },
        historyMenuClick(evt) {
            this.dialogAction = evt.actionName;
            if (this.dialogAction === "restore") {
                this.infoRestoreDialog(evt.timelineItem);
                this.restoreConfirmationDialog = true;
            }
        },
        infoRestoreDialog(timelineItem) {
            this.restoredDocumentData = timelineItem || this.currentPreviewDocument;
            const restoreElementData = timelineItem && timelineItem.timestamp ? `${this.dateFormatter(timelineItem.timestamp)}`
                : `${this.dateFormatter(this.currentPreviewDocument.timestamp)}`;
            this.restoreDialogMessage = this.$t("versioning.restoreDialogInfo", { interfaceName: this.selected[0].name, date: restoreElementData });
        },
        confirmRestore() {
            if ((this.previewDone && this.restoredDocumentData && this.restoredDocumentData !== this.currentPreviewDocument) || !this.previewDone) {
                const payload = {
                    module: "DocumentBuilder",
                    applicationId: this.currentApp.id,
                    elementId: this.selected[0].id,
                    commitId: this.restoredDocumentData.commitId
                };
                this.getDocumentHistoryPreviewData(payload).then(data => {
                    if (data && data.data) {
                        this.$root.$emit("hideSaveBtn", false);
                        this.$root.$emit("showCheckedSaveBtn", false);
                        this.$root.$emit("confirmRestore", this.$route.name);
                        this.selected = JSON.parse(JSON.stringify([{ ...data.data }]));
                        this.updateSelectedDoc(this.selected[0]);

                        this.$toast.showNotify({
                            type: "success",
                            message: this.$t("versioning.confirmRestoreNotify"),
                            timeout: 2000
                        });
                    }
                });
            }
            this.$root.$emit("showPublish", { noProcesses: this.currentApp.hasOwnProperty("nrOfProcesses") ? !this.currentApp.nrOfProcesses
                : !this.processList.length,
            showPublish: publishAppPermissions(this.currentApp, this.getCurrentAppUserPermissions) });
            this.saveHistoryActiveCommitId = null;
            this.resetSaveHistory();
            this.dirtyFromRestore = true;
            this.$store.commit("main/setInterfaceDirty", true);
            this.saveHistoryModal = false;
            this.setReadOnly = false;
            this.inPreviewMode = false;
            this.$root.$emit("hideSaveBtn", false);
            this.$root.$emit("showCheckedSaveBtn", false);
            this.$root.$emit("confirmRestore", this.$route.name);
        },
        getNoteData() {
            if (this.currentPreviewDocument) {
                const payload = {
                    module: "DocumentBuilder",
                    applicationId: this.currentApp.id,
                    elementId: this.selected[0].id,
                    commitId: this.currentPreviewDocument.commitId
                };
                this.getNote(payload).then(data => {
                    if (data) {
                        this.note = data.data;
                        this.createNote = !this.note;
                        this.confirmLabel = this.note ? this.$t("versioning.updateNote") : this.$t("versioning.createNote");
                        this.noteDialogTitle = this.note
                            ? this.$t("versioning.dialogTitleEdit", { date: `${this.dateFormatter(this.currentPreviewDocument.timestamp)}` })
                            : this.$t("versioning.dialogTitleCreate", { date: `${this.dateFormatter(this.currentPreviewDocument.timestamp)}` });
                    }
                    this.noteDialog = true;
                });
            }
        },
        actionNote(noteData) {
            const payload = {
                module: "DocumentBuilder",
                applicationId: this.currentApp.id,
                elementId: this.selected[0].id
            };
            payload.commitId = noteData ? noteData.timelineItem.commitId : this.currentPreviewDocument.commitId;
            payload.note = noteData ? noteData.note : this.note;
            let messageLabel = "";
            if (noteData) {
                messageLabel = this.dialogAction === "edit" ? this.$t("versioning.updateNoteDialog") : this.$t("versioning.saveNote");
            } else {
                messageLabel = this.confirmLabel === "Update" ? this.$t("versioning.updateNoteDialog") : this.$t("versioning.saveNote");
            }
            this.saveDeleteNote(payload).then((data) => {
                if (data) {
                    this.$toast.showNotify({
                        type: "success",
                        message: messageLabel,
                        timeout: 500,
                        hasClose: true
                    });
                    if (noteData) {
                        noteData.timelineItem.note = noteData.note;
                        this.keyUpdate += 1;
                    } else if (this.currentPreviewDocument) {
                        this.currentPreviewDocument.note = this.note;
                    }
                }
            },
            err => { console.log("error", err); });
        },
        refreshAfterDelete(id) {
            this.getDocumentsList().then(() => {
                const { name } = this.selected[0];
                if (this.$route.name === "documents") {
                    if (!this.$oneAtATime.state.$currentRoomEmpty && name) {
                        this.$toast.showNotify({
                            type: "info",
                            message: `${name} ${this.$t("documents.deleteBy")} ${this.$oneAtATime.state.$currentEditingUser}.`,
                            timeout: 3000
                        });
                        this.selected = [defaultDocument()];
                        this.$oneAtATime.destroyCurrentRoom();
                        this.toastExist = false;
                        this.refreshNotify();
                        this.$router.go(0);
                    } else if (!this.deletedDoc) {
                        this.notifyListUpdated();
                    }
                } else if (this.selected[0].id === id) {
                    this.selected = [defaultDocument()];
                }
                this.deletdeDoc = false;
            });
        },
        refreshAfterRename(id) {
            this.toastExist = false;
            if ((this.$route.name === "documents") && !this.currentSession && !this.docRenamed) {
                const newDocument = this.getExistingDocs.find(el => el.id === id);
                if (newDocument) {
                    this.$toast.showNotify({
                        type: "info",
                        message: `${newDocument.name} ${this.$t("documents.renamed")} `,
                        timeout: 1000
                    });
                }
            }
            const documentExist = id ? this.getExistingDocs.find(el => el.id === id) : null;
            if (documentExist && this.selected[0].id === documentExist.id && !this.currentSession && !this.docRenamed
                && !this.$oneAtATime.state.$currentRoomEmpty) {
                setTimeout(() => {
                    this.docUpdateNotify = this.$toast.showNotify({
                        type: "info",
                        message: `${documentExist.name} ${this.$t("documents.documentUpdateToast")} `,
                        buttonLabel: `${this.$t("documents.refresh")}`,
                        timeout: 0,
                        hasClose: false,
                        actionEvent: this.getDocData
                    });
                }, 1000);
            }
            if (!this.currentSession) {
                this.getDocumentsList();
            }
            this.currentSession = false;
            this.docRenamed = false;
        },
        refreshList(data) {
            const documentExist = data ? this.getExistingDocs.find(el => el.id === data) : null;
            if (documentExist) {
                if (this.$oneAtATime.state.$currentRoomEmpty && !this.isReadonlyPermiss) {
                    this.getDocumentsList().then(() => {
                        if (this.$route.name === "documents") {
                            if (this.selected[0].id !== documentExist.id) {
                                const newDocument = this.getExistingDocs.find(el => el.id === data);
                                this.$toast.showNotify({
                                    type: "success",
                                    message: `${newDocument.name} ${this.$t("documents.updated")} `,
                                    timeout: 1000
                                });
                            }
                        }
                    });
                } else if (this.selected[0].id === documentExist.id && !this.toastExist) {
                    this.docUpdateNotify = this.$toast.showNotify({
                        type: "info",
                        message: `${documentExist.name} ${this.$t("documents.documentUpdateToast")} `,
                        buttonLabel: `${this.$t("documents.refresh")}`,
                        timeout: 0,
                        hasClose: false,
                        actionEvent: this.getDocData
                    });
                    this.toastExist = true;
                }
            } else if (this.$route.name === "documents") {
                this.getDocumentsList().then(() => {
                    this.notifyListUpdated();
                });
            }
        },
        refreshWithDraft() {
            this.getDocumentsList().then(() => {
                this.updateDocumentList(this.draftDoc);
                this.selected[0] = this.draftDoc;
                this.notifyListUpdated();
            });
        },
        notifyListUpdated() {
            this.$toast.showNotify({
                type: "info",
                message: this.$t("documents.listUpdate"),
                timeout: 1000
            });
        },
        focusSelectedDoc() {
            this.$nextTick(() => {
                const focusedDoc = document.getElementById(`idDoc-${this.selected[0].id}`);
                if (focusedDoc) {
                    focusedDoc.scrollIntoView(true);
                }
            });
        },
        getDocData() {
            this.checkUpdatesOnDoc(this.selected[0].id);
            this.refreshNotify();
        },
        refreshNotify() {
            if (this.docUpdateNotify) {
                this.docUpdateNotify();
                this.toastExist = false;
            }
        },
        showEditPopup(event) {
            this.validateValueId = event.item.id;
            this.validateValueName = event.item.name;
            if (!this.isReadonlyPermiss) {
                this.openRenameDialog = true;
            }
        },
        openDoc(docId) {
            this.showDoc = true;
            this.newSelectionId = docId;
            this.$store.commit("main/setSaveBtnVisible", false);
            this.$root.$emit("hideSaveBtn", false);
            this.$store.commit("main/setInterfaceDirty", false);
            this.$root.$emit("showCheckedSaveBtn", true);
            this.$emit("previewSaveHistoryClose", this.$route.name);
            this.$root.$emit("showPublish", { noProcesses: this.currentApp.hasOwnProperty("nrOfProcesses")
                ? !this.currentApp.nrOfProcesses : !this.processList.length,
            showPublish: this.publishAppPermissions(this.currentApp, this.getCurrentAppUserPermissions) });
            if (this.selected[0].id !== docId) {
                this.checkUpdatesOnDoc(docId);
                this.getDocumentDetails(docId).then((data) => {
                    this.changeInDoc = false;
                    this.selected = JSON.parse(JSON.stringify([{ ...data.data }]));
                    this.updateSelectedDoc(this.selected[0]);
                    this.docPreview = JSON.parse(JSON.stringify([{ ...data.data }]));
                    this.refreshNotify();
                    this.resetSaveHistory();
                    this.dirtyFromRestore = false;
                    this.setReadOnly = false;
                    this.inPreviewMode = false;
                });
            }
            if (this.$route.params.documentId !== docId) {
                this.$router.replace({ params: { documentId: docId } });
            }
            this.$emit("previewSaveHistoryClose", this.$route.name);
            this.$root.$emit("previewSaveHistoryHeaderClose", this.$route.name);
            this.inPreviewMode = false;
        },
        save() {
            if (this.showDoc) {
                this.updateExistingDoc(this.selected[0]);
                this.postNewDocument(this.selected[0]).then((data) => {
                    this.docPreview = JSON.parse(JSON.stringify(this.selected));
                    if (!this.docPreview[0].hasOwnProperty("isActive")) {
                        this.getDocumentDetails(this.docPreview[0].id).then((response) => {
                            this.docPreview[0] = JSON.parse(JSON.stringify(response.data));
                            const newSelectedDoc = {};
                            Object.entries(response.data).forEach(([key, value]) => {
                                if (this.selected[0][key]) {
                                    if (key === "pages") {
                                        newSelectedDoc[key] = value;
                                    } else {
                                        newSelectedDoc[key] = this.selected[0][key];
                                    }
                                } else {
                                    newSelectedDoc[key] = value;
                                }
                            });
                            this.selected = [_merge(newSelectedDoc, this.selected[0])];
                            this.updateSelectedDoc(this.selected[0]);
                            this.docPreview[0].documentCommitId = data.data.commitId;
                            this.selected[0].documentCommitId = data.data.commitId;
                        });
                    } else {
                        this.docPreview[0].documentCommitId = data.data.commitId;
                    }

                    this.$store.commit("main/setInterfaceDirty", false);
                    this.$root.$emit("showCheckedSaveBtn", true);
                    this.selectedFromState = null;
                    this.checkFreshAppData();
                    this.$toast.showNotify({
                        type: "success",
                        message: this.$t("generic.savedSuccessfully"),
                        timeout: 500
                    });
                    this.dirtyFromRestore = false;
                    this.focusSelectedDoc();
                });
                this.draft = false;
            } else {
                const listToSend = this.getExistingDocs.map(element => ({
                    name: element.name,
                    id: element.id
                }));
                const payload = {
                    docsList: listToSend,
                    applicationId: this.currentApp.id
                };
                this.saveDocumentsListName(payload).then(() => {
                    this.checkFreshAppData();
                    this.$toast.showNotify({
                        type: "success",
                        message: this.$t("generic.savedSuccessfully"),
                        timeout: 500
                    });
                });
            }
            this.changeInDoc = false;
        },
        checkFreshAppData() {
            this.getAppSettingsInfo(this.currentApp).then(data => {
                this.currentApp.publishStatus = data.data.publishStatus;
                this.$store.commit("apps/setCurrentApp", this.currentApp);
            });
        },
        // delete for 2 users
        deleteDoc(doc) {
            this.selected[0] = doc;
            this.deleteDocDlg = true;
        },
        okDeleteDocDlg() {
            this.$oneAtATime.createRoom("documents", this.selected[0].id, "delete");
        },
        cancelActionDlg() {
            this.$oneAtATime.destroyCurrentRoom();
            this.selected[0] = defaultDocument();
            this.deleteDocDlg = false;
        },
        okAction() {
            this.changeInDoc = false;
            this.addNewDoc();
        },
        addNewDoc() {
            if (this.changeInDoc) {
                this.wrnMessage = this.$t("documents.wrnMessage");
                this.newSelectionId = null;
                this.openDialog = true;
            } else {
                const obj = {
                    id: uid(),
                    applicationId: this.currentApp.id,
                    name: this.generateNewDocName(),
                    template: "",
                    repeatableBlockCounter: 0

                    // rules: [],
                    // repeatableParameters: [],
                    // blockCounter: 0,

                };
                this.draft = true;
                this.selected = [obj];
                this.updateSelectedDoc(obj);
                this.refreshNotify();
                this.focusSelectedDoc();
                this.$oneAtATime.createRoom("documents", obj.id);
                this.$store.commit("main/setSaveBtnVisible", false);
                this.$root.$emit("hideSaveBtn", false);
                this.$root.$emit("showCheckedSaveBtn", false);
                this.showDoc = true;
                if (this.$route.params.documentId !== obj.id) {
                    this.$router.replace({ params: { documentId: obj.id } });
                }
            }
        },

        generateNewDocName() {
            let docName = "";
            if (this.existingDocs.length) {
                let numberToReturn = 0;
                this.existingDocs.forEach(curr => {
                // check if current names contains copy numbering EX: Untitled document (1)
                    const number = parseInt(curr.name.match(/((\d+))/), 10);
                    const regExp = /\(([^)]+)\)/;
                    // eslint-disable-next-line
                    if (!isNaN(number) && regExp.exec(curr.name)) {
                        if (parseInt(number, 10) > numberToReturn) {
                            numberToReturn = parseInt(number, 10);
                        }
                    }
                    // generate unique document names based on the existing one
                    docName = `${this.$t("documents.untitledDoc")} (${numberToReturn + 1})`;
                });
            } else {
                docName = this.$t("documents.untitledDoc");
            }
            return docName;
        },
        exportDoc(doc, preview, isPdf) {
            if (!preview) {
                this.getDocumentDetails(doc.id).then((data) => {
                    this.objToSend = {
                        html: data.data.template,
                        pages: data.data.pages,
                        applicationId: this.getCurrentApplicationId,
                        repeatableParameters: data.data.repeatableParameters
                    };
                    this.postDocumentTemplate({ objToSend: this.objToSend, name: data.data.name, docType: isPdf });
                });
            } else {
                this.objToSend = {
                    html: doc.template,
                    pages: doc.pages,
                    applicationId: this.getCurrentApplicationId,
                    repeatableParameters: doc.repeatableParameters
                };
                this.postDocumentTemplate({ objToSend: this.objToSend, name: doc.name, docType: isPdf });
            }
        },
        validateValue(val) {
            this.validateValueChecks(val);
            const checkIfRouteListDoc = !this.$route.params.documentId;
            if ((checkIfRouteListDoc || !this.isReadonly) && !this.nameError && val) {
                this.$oneAtATime.createRoom("documents", this.validateValueId, "rename");
            }
            this.openRenameDialog = this.nameError;
            return !this.nameError;
        },
        validateValueChecks(val) {
            this.nameError = false;
            this.errorMessage = "";
            if (val !== undefined) {
                if (!val) {
                    this.nameError = true;
                } else {
                    this.existingDocs.forEach(curr => {
                        const name = val.toLowerCase().trim();
                        if ((curr.name.toLowerCase() === name && curr.id !== this.validateValueId) || val.length >= 400) {
                            this.nameError = true;
                            this.errorMessage = val.length >= 400 ? this.$t("documents.maxLengthNameErr") : this.$t("documents.uniqueName");
                        }
                    });
                }
            }
        },
        setSaveButtonDisplay() {
            const readonlyPerm = this.$route.params && this.$route.params.permissions ? this.$route.params.permissions.readonly : false;
            this.$store.commit("main/setSaveBtnVisible", readonlyPerm);
            this.$root.$emit("setReadonlyTag", readonlyPerm);
        },
        // when edit or export
        checkUpdatesOnDoc(docId) {
            let docCommitId = "";
            const doc = this.existingDocs.find(elem => elem.id === docId);
            if (doc && this.currentApp && this.currentApp.id) {
                this.getDocCommitId(docId).then(rsp => {
                    docCommitId = rsp.data;
                    if (docCommitId !== doc.documentCommitId || !doc.hasOwnProperty("template")) {
                        this.getDocumentDetails(docId).then(data => {
                            this.selected = JSON.parse(JSON.stringify([{ ...data.data }]));
                            this.updateExistingDoc(this.selected[0]);
                            this.updateSelectedDoc(this.selected[0]);
                            const { id } = this.selected[0];
                            if (!this.isReadonlyPermiss) {
                                this.$oneAtATime.createRoom("documents", id);
                            }
                        });
                    } else {
                        this.selected = JSON.parse(JSON.stringify([{ ...this.existingDocs.find(elem => elem.id === docId) }]));
                        const { id } = this.selected[0];
                        if (!this.isReadonlyPermiss) {
                            this.$oneAtATime.createRoom("documents", id);
                        }
                        if (this.selected[0]) {
                            this.updateSelectedDoc(this.selected[0]);
                        }
                    }
                });
            }
        },
        modalActionSaveHistory(evt) {
            if (evt === "close") {
                this.saveHistoryModal = false;
                if (this.inPreviewMode) {
                    this.savePreviewToast = this.$toast.showNotify({
                        type: "info",
                        message: `${i18n.t("versioning.previewToastTitle")} ${this.dateFormatter(this.timeStampPreview)}`,
                        caption: this.$t("versioning.previewToastText"),
                        code: "preview-ui",
                        timeout: 30000000
                    });
                }
            }
        },
        getSaveHistory() {
            if (this.saveHistoryHasMoreItems) {
                const payload = {
                    searchType: "SAVE_HISTORY",
                    module: "DocumentBuilder",
                    applicationId: this.currentApp.id,
                    elementId: this.selected[0].id,
                    page: this.saveHistoryCurrentPage,
                    size: 10
                };
                this.getHistoryData(payload).then(data => {
                    if (data && data.data && data.data.history) {
                        this.saveHistoryData = this.saveHistoryData.concat(data.data.history);
                        this.saveHistoryHasMoreItems = data.data.hasMorePages;
                    }
                    this.saveHistoryModal = true;
                });
            } else {
                this.saveHistoryModal = true;
            }
        },
        resetSaveHistory() {
            this.saveHistoryData = [];
            this.saveHistoryCurrentPage = 0;
            this.saveHistoryHasMoreItems = true;
            this.saveHistoryActiveCommitId = null;
            if (this.savePreviewToast) {
                this.savePreviewToast();
            }
        },
        modalAction(evt) {
            if (evt === "close") {
                this.changeHistoryModal = false;
            }
        },
        menuItemChangeHistoryClicked(evt) {
            if (evt.menuOptionClicked === "recover") {
                const myDate = new Date();
                const offsetInMinutes = myDate.getTimezoneOffset();
                const payload = {
                    module: "DocumentBuilder",
                    applicationId: this.currentApp.id,
                    elementId: evt.elementId,
                    commitId: evt.items[0].commitId,
                    offsetMinutes: parseInt(offsetInMinutes, 10)
                };
                this.recoverDocument(payload).then(response => {
                    if (response && response.data) {
                        if (response.data.isSuccessful === true) {
                            this.changeHistoryModal = false;
                            this.currentSession = true;
                            this.$toast.showNotify({
                                type: "success",
                                message: this.$t("versioning.documentRecovered"),
                                timeout: 2000,
                                hasClose: true
                            });
                            this.checkFreshAppData();
                        } else {
                            const errorCodes = {
                                ALREADY_RECOVERED: this.$t("versioning.documentAlreadyRecovered"),
                                MISSING_GUI: this.$t("versioning.documentNotFound"),
                                NOT_DELETE: this.$t("versioning.interfaceNotDeleteEvent")
                            };
                            if (errorCodes[response.data.errorCode]) {
                                this.$toast.showNotify({
                                    type: "error",
                                    message: errorCodes[response.data.errorCode],
                                    timeout: 3000,
                                    hasClose: true
                                });
                            }
                        }
                    }
                });
            }
        },
        resetChangeHistory() {
            this.changeHistoryData = [];
            this.changeHistoryCurrentPage = 0;
            this.changeHistoryHasMoreItems = true;
        },
        getChangeHistory() {
            if (this.changeHistoryHasMoreItems) {
                const payload = {
                    searchType: "CHANGE_HISTORY",
                    module: "DocumentBuilder",
                    applicationId: this.currentApp.id,
                    page: this.changeHistoryCurrentPage,
                    size: 10
                };
                this.getHistoryData(payload).then(data => {
                    if (data && data.data && data.data.history) {
                        this.changeHistoryData = this.changeHistoryData.concat(data.data.history);
                        this.changeHistoryHasMoreItems = data.data.hasMorePages;
                    }
                    this.changeHistoryModal = true;
                });
            } else {
                this.changeHistoryModal = true;
            }
        },
        rename(documentNameObj) {
            if (documentNameObj.newName) {
                const sameNameDocument = this.existingDocs.find(elem => elem.name === documentNameObj.newName);
                if (sameNameDocument) {
                    this.$toast.showNotify({
                        type: "error",
                        message: this.$t("documents.sameNameDocument"),
                        timeout: 2000
                    });
                } else if (this.selectedDoc[0].id) {
                    if (this.draft) {
                        const currentDoc = { ...this.selectedDoc[0], name: documentNameObj.newName };
                        this.updateSelectedDoc(currentDoc);
                        this.selected[0].name = documentNameObj.newName;
                    } else {
                        this.docRenamed = true;
                        const currentDoc = { ...this.selectedDoc[0], name: documentNameObj.newName };
                        this.updateSelectedDoc(currentDoc);
                        const payload = {
                            appId: this.selectedDoc[0].applicationId,
                            id: this.selectedDoc[0].id,
                            name: documentNameObj.newName
                        };
                        this.saveDocumentsListName(payload).then((rsp) => {
                            this.$nextTick(() => {
                                this.selected[0].documentCommitId = rsp.commitId;
                                this.selected[0].name = documentNameObj.newName;
                                this.selectedDoc[0].documentCommitId = rsp.commitId;
                                delete this.selected[0].timestamp;
                                delete this.selected[0].description;
                                this.checkFreshAppData();
                            });
                            this.$toast.showNotify({
                                type: "success",
                                message: this.$t("documents.renamedSuccessfully"),
                                timeout: 2000
                            });
                        });
                        this.$store.commit("main/setInterfaceDirty", false);
                    }
                }
            } else {
                this.$toast.showNotify({
                    type: "info",
                    message: this.$t("versioning.emptyNameNotif"),
                    timeout: 2000
                });
            }
        },
        getSaveHistoryPreview(timelineItem) {
            const isSamePreview = this.saveHistoryActiveCommitId ? this.saveHistoryActiveCommitId === timelineItem.commitId : false;
            if (!this.standaloneTypes.has(timelineItem.commitType) && !isSamePreview) {
                this.currentPreviewDocument = timelineItem;
                const dirtyNow = this.changeInDoc || this.dirtyFromRestore;
                if (dirtyNow && !this.inPreviewMode) {
                    this.openDialogDraftPreview = dirtyNow;
                } else {
                    this.getSaveHistoryItemPreview();
                }
            }
        },
        getSaveHistoryItemPreview() {
            if (!this.standaloneTypes.has(this.currentPreviewDocument.commitType)) {
                this.$root.$emit("previewSaveHistoryLoadStart", this.$route.name);
                const payload = {
                    module: "DocumentBuilder",
                    applicationId: this.currentApp.id,
                    elementId: this.selected[0].id,
                    commitId: this.currentPreviewDocument.commitId
                };
                this.getDocumentHistoryPreviewData(payload).then(data => {
                    if (data && data.data) {
                        this.$root.$emit("previewSaveHistoryLoadEnd", this.$route.name);
                        this.$root.$emit("hideSaveBtn", true);
                        this.$root.$emit("showPublish", false);

                        this.timeStampPreview = data.data.timestamp;

                        this.previewDone = true;
                        this.setReadOnly = true;
                        this.inPreviewMode = true;
                        this.dirtyFromRestore = false;
                        this.saveHistoryActiveCommitId = data.data.documentCommitId;
                        this.selected = JSON.parse(JSON.stringify([{ ...data.data }]));
                        delete this.selected[0].timestamp;
                        delete this.selected[0].description;
                        this.updateSelectedDoc(this.selected[0]);
                    } else {
                        this.$root.$emit("previewSaveHistoryClose", this.$route.name);
                    }
                });
            }
        },
        dateFormatter(dateToFormat) {
            const newData = dateToFormat ? date.formatDate(dateToFormat, APP_DATE_DOT_FORMAT).split(".") : "";
            const data = new Date();
            data.setMonth(newData[1] - 1);
            const year = newData[2].split(" ")[0];
            const hour = newData[2].split(" ")[1].substring(0, 5);
            return `${data.toLocaleString("en-US", { month: "long" })} ${newData[0]}, ${year}  ${i18n.t("versioning.at")} ${hour}`;
        },
        changeSearchUrl(value) {
            const searchText = value.trim();
            const queriesAreDifferent = JSON.stringify({ search: searchText }) !== JSON.stringify(this.$route.query);
            const query = searchText ? { search: searchText } : {};
            if (this.isActive && queriesAreDifferent) {
                this.$router.replace({ path: `/applications/${this.currentApp.id}/documentTemplates`, query });
            }
        },
        renameFromBc() {
            this.$root.$on("bc__currentDocument__rename", data => {
                this.rename(data);
            });
        }
    }
};
